import { ClientPortfolioPaymentFrequencyEnum } from "web_myplann/Infrastructure/Api/Api";
import type { NonLifeInsuranceFormInput } from "web_myplann/Portfolio/Forms/NonLifeInsuranceForm/nonLifeInsuranceFormSchema";

export const NON_LIFE_INSURANCE_FORM_DEFAULT_VALUES: NonLifeInsuranceFormInput =
	{
		name: "",
		contractNumber: "",
		producer: "",
		product: "",
		insurance: null,
		insurancePeriod: null,
		paymentFrequency: ClientPortfolioPaymentFrequencyEnum.Monthly,
		signedAt: null,
		startAt: null,
		endAt: null,
	};
